import { Injectable, inject } from '@angular/core';
import { CasesState } from '../../states/cases.state';
import { GetCasesStateResult } from './get-cases-state.result';

/**
 * GetCasesState use case.
 * Provides read-only access to Cases state for presentation layer.
 * This maintains Clean Architecture by preventing direct State injection in presentation.
 */
@Injectable({ providedIn: 'root' })
export class GetCasesStateUseCase {
  private readonly _state = inject(CasesState);

  public execute(): GetCasesStateResult {
    return {
      cases: this._state.cases,
      selectedCase: this._state.selectedCase,
      loading: this._state.loadingCases,
      saving: this._state.savingCases,
      error: this._state.errorCases,
      casesCount: this._state.casesCount,
      hasCases: this._state.hasCases,
      closingCase: this._state.closingCase,
      errorClosingCase: this._state.errorClosingCase,
      // Cases list (summary data)
      casesList: this._state.casesList,
      casesListTotalElements: this._state.casesListTotalElements,
      loadingCasesList: this._state.loadingCasesList,
      errorCasesList: this._state.errorCasesList,
      casesListCount: this._state.casesListCount,
      // Messages
      messages: this._state.messages,
      loadingMessages: this._state.loadingMessages,
      addingMessage: this._state.addingMessage,
      markingMessagesAsRead: this._state.markingMessagesAsRead,
      errorMessages: this._state.errorMessages,
      // Work notes
      workNotes: this._state.workNotes,
      loadingWorkNotes: this._state.loadingWorkNotes,
      addingWorkNote: this._state.addingWorkNote,
      errorWorkNotes: this._state.errorWorkNotes,
      // Attachments
      attachments: this._state.attachments,
      loadingAttachments: this._state.loadingAttachments,
      uploadingAttachment: this._state.uploadingAttachment,
      deletingAttachmentId: this._state.deletingAttachmentId,
      errorAttachments: this._state.errorAttachments,
      // Linked cases
      linkedCases: this._state.linkedCases,
      loadingLinkedCases: this._state.loadingLinkedCases,
      linkingCase: this._state.linkingCase,
      unlinkingCase: this._state.unlinkingCase,
      errorLinkedCases: this._state.errorLinkedCases,
      // Checklist steps
      checklistSteps: this._state.checklistSteps,
      loadingChecklistSteps: this._state.loadingChecklistSteps,
      updatingChecklistStep: this._state.updatingChecklistStep,
      errorChecklistSteps: this._state.errorChecklistSteps,
      hasChecklistSteps: this._state.hasChecklistSteps,
      completedChecklistSteps: this._state.completedChecklistSteps,
    };
  }
}
